export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/fromDownPayment.90abbcf8.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};